import React from 'react';
import {ChartData, ChartOptions} from "chart.js";
import {toTitleCase} from "services/string";
import {Line as LineChart} from "react-chartjs-2";
import HoverAnnotation from "../../../plugins/hover-annotation";

import type {InsightInterval, OperatorTriggerInsight} from "types/OperatorInsights";

// Types ----

type TriggerExecutionsChartProps = {
    data: OperatorTriggerInsight
    interval: InsightInterval
    compare: InsightInterval
}

// Components ----

function TriggerExecutionsChart({compare, data, interval}: TriggerExecutionsChartProps) {

    const chartData: ChartData<'line', any> = {
        labels: data.metrics.map(metric => metric.time),
        datasets: [
            {
                label: "Current period",
                backgroundColor: "rgba(99, 102, 241, 0.8)",
                borderColor: "rgba(79, 70, 229, 1)",
                pointBackgroundColor: "rgba(99, 102, 241, 1)",
                data: data.metrics.map(metric => metric.measurements.trigger_executions.value),
            },
            {
                label: `Previous ${compare}`,
                backgroundColor: "rgba(99,102,241,0.4)",
                borderColor: "rgba(79, 70, 229, 0.4)",
                pointBackgroundColor: "rgba(99, 102, 241, 0.4)",
                data: data.metrics.map(metric => metric.measurements.trigger_executions.comparison),
            }
        ],
    }

    const chartOptions: ChartOptions<'line'> = {
        plugins: {
            legend: {
                display: true,
            },
            tooltip: {
                mode: "index",
                intersect: false,
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: toTitleCase(interval)
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Trigger Executions'
                },
                grid: {
                    display: true
                },
                min: 0
            }
        }
    }

    return (
        <LineChart data={chartData} options={chartOptions} plugins={[HoverAnnotation]} />
    );
}

export default TriggerExecutionsChart;